"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isDefined(value) {
    return value !== undefined && value !== null;
}
exports.isDefined = isDefined;
exports.isPromise = function (val) {
    return val && val.then !== undefined;
};
exports.times = function (n, fn) {
    return Array(n)
        .fill(undefined)
        .map(function (_, i) { return fn(i); });
};
